export const LOCAL_STORAGE_PERSONAL_PLAN_PERIOD_TYPE_KEY = 'personalPlanPeriodType';
export const LOCAL_STORAGE_PERSONAL_PLAN_EXPANDED_ROWS_KEY = 'personalPlanExpandedRows';
